<template>
  <div class="my-wrap finance-wrap">
    <div class="withdraw-frame withdraw-m-frame">
      <div class="my-withdraw-mobile-package withdraw-mobile">
        <div class="mobile-frame">
          <div class="channel-text-n">
            {{ $t('Bao.select_withdrawal_method') }}
          </div>

          <!-- 上方選單 -->
          <div class="mobile-wallet-card">
            <div class="wallet-list" @click="$router.push('/deposit')">
              {{ $t('Bao.deposit') }}
            </div>
            <div class="wallet-list-on">
              {{ $t('Bao.withdraw_menu') }}
            </div>
            <div class="wallet-list" @click="$router.push('/user/wallet-history')">
              {{ $t('Bao.transaction-index') }}
            </div>
          </div>
          <div class="deposit-bg">
            <div class="bank-choice">
              <div
                v-if="availableWithdrawalTypes[2]"
                class="bank-electron"
                :class="{ active: isElectronActive }"
                @click="goNextStep(2, 'electron')"
              >
                <p>{{ $t('Bao.e_wallet') }}</p>
              </div>
              <div
                v-if="availableWithdrawalTypes[1]"
                class="bank-bank"
                :class="{ active: isBankActive }"
                @click="goNextStep(1, 'bank')"
              >
                <p>{{ $t('Bao.bank_card_2') }}</p>
              </div>
              <div
                v-if="availableWithdrawalTypes[3]"
                class="bank-bitcoin"
                :class="{ active: isBitcoinActive }"
                @click="goNextStep(3, 'bitcoin')"
              >
                <p>{{ $t('Bao.cryptocurrency_for_withdrawal') }}</p>
              </div>
            </div>
          </div>

          <div class="deposit-frame-n">
            <p>{{ $t('Bao.select_a_wallet') }}</p>
          </div>

          <template v-if="wallets.length > 0">
            <div class="my-wallet-out-frame">
              <div
                :class="{'channel-cash-card-on': postForm.wallet === 'common', 'channel-cash-card': postForm.wallet !== 'common'}"
                @click="selectWallet(wallets[0])"
              >
                <div class="wallet-out-card">
                  <span>{{ $t('Bao.main_wallet') }}</span>
                  <span class="cash-card-title">{{ brand.currency }} {{ formattedPrice(wallets[0].gold) | numberFormat }}</span>
                </div>
              </div>
              <div
                :class="{'channel-cash-card-on': postForm.wallet === 'commission', 'channel-cash-card': postForm.wallet !== 'commission'}"
                @click="selectWallet(wallets[1])"
              >
                <div class="wallet-out-card">
                  <span>{{ $t('Bao.commission_wallet') }}</span>
                  <span class="cash-card-title">{{ brand.currency }} {{ formattedPrice(wallets[1].gold) | numberFormat }}</span>
                </div>
              </div>
            </div>
          </template>

          <!--  mobile出金選項 -->
          <div class="slider-form withdraw-slider-form">
            <div class="slider">
              <form class="row-frame dep-form-frame colu-12 form-row-gap">
                <div class="colu colu-8">
                  <label class="colu-12 for-label" for="カード/口座-mb">{{ $t('Bao.card_or_address') }}</label>
                  <select
                    id="カード/口座-mb"
                    v-model="postForm.member_bank_id"
                    class="for-select inpType"
                    @change="selectBank"
                  >
                    <option :value="selectedBankName">
                      {{ selectedBankName }}
                    </option>
                    <template v-for="(bank, key) in myBanks">
                      <option
                        v-if="bank.bank_type === type"
                        :key="key"
                        :value="bank.id"
                      >
                        {{ bank.card_number }}
                      </option>
                    </template>
                  </select>
                </div>
                <div class="colu colu-4">
                  <button class="btn btn-primary button-style btn-blackDarkBG" @click.prevent="$router.push('/user/bank')">
                    <img :src="getThemeImagePath('add.svg')" alt="">{{ $t('Bao.new_bank_card_1') }}{{ $t('Bao.new_bank_card_2') }}
                  </button>
                </div>

                <div class="colu colu-8">
                  <label class="colu-12 for-label" for="出金額を入力してください-mb">{{ $t('Bao.please_enter_withdrawal_amount') }}</label>
                  <input
                    id="出金額を入力してください-mb"
                    v-model="postForm.amount"
                    class="for-input inpType"
                    type="text"
                    :placeholder="$t('Bao.input_withdrawal_amount')"
                  >
                </div>
                <div class="colu colu-4">
                  <button class="btn btn-primary button-style btn-blackDarkBG" @click.prevent="setAllAmount()">
                    {{ $t('Bao.withdrawal_all_1') }}{{ $t('Bao.withdrawal_all_2') }}
                  </button>
                </div>

                <template v-if="selectedBankTypeCode === 'JetonPay'">
                  <div class="form-input f-frame">
                    <label class="title-n" for="withdraw-amount">{{ $t('Bao.jeton_account') }}</label>
                    <div class="wallet-amount-frame">
                      <input
                        v-model="withdrawal_info.uid"
                        class="withdraw-amount-input"
                        type="text"
                        :placeholder="$t('Bao.jeton_account')"
                        autocomplete="off"
                        @input="checkJetonErrors"
                      >
                    </div>
                    <div v-for="error in jetonErrors" :key="error" class="help-block">
                      {{ error }}
                    </div>
                  </div>
                </template>

                <template v-if="selectedBankTypeCode === 'VegaWallet'">
                  <div class="form-input f-frame">
                    <label class="title-n" for="withdraw-amount">{{ $t('Bao.deposit_account') }}</label>
                    <div class="wallet-amount-frame">
                      <input
                        v-model="withdrawal_info.uid"
                        class="withdraw-amount-input"
                        type="text"
                        :placeholder="$t('Bao.deposit_account')"
                        autocomplete="off"
                        @input="checkAccountErrors"
                      >
                    </div>
                    <div v-for="error in accountErrors" :key="error" class="help-block">
                      {{ error }}
                    </div>
                    <label class="title-n" for="withdraw-amount">
                      {{ $t('Bao.deposit_password') }}
                    </label>
                    <div class="wallet-amount-frame">
                      <input
                        v-model="withdrawal_info.password"
                        v-validate="'required'"
                        class="withdraw-amount-input"
                        type="password"
                        name="password"
                        :placeholder="$t('Bao.deposit_password')"
                        autocomplete="off"
                      >
                    </div>
                    <div v-if="errors.has('password')" class="help-block">
                      {{ $t("Bao.deposit_password_error") }}
                    </div>
                  </div>
                </template>

                <div class="withdraw-detail-frame">
                  <div class="detailList">
                    <b class="wDtitle">{{ $t('Bao.withdraw_limit') }}</b>
                    <span class="wDamount">{{ brand.currency }} {{ withdrawalLimit }}</span>
                  </div>
                  <div class="detailList">
                    <b class="wDtitle">{{ $t('Bao.withdrawal_amount_tip_line_2') }}</b>
                    <span class="wDamount">{{ brand.currency }} {{ wallets.length > 0 ? selectedWallet.amount_limit.max : 0 | numberFormat }}</span>
                  </div>
                </div>

                <div class="colu colu-12">
                  <label class="colu-12 for-label" for="inputPassword-mb">{{ $t("Bao.withdrawal_password") }}</label>
                  <input
                    id="inputPassword-mb"
                    v-model="postForm.withdrawal_pass"
                    class="for-input inpType"
                    type="password"
                    :placeholder="$t('Bao.withdrawal_password_default')"
                  >
                </div>

                <div class="withdraw-detail-frame">
                  <div class="detailList">
                    <b class="wDtitle">{{ $t('Bao.total_amount') }}</b>
                    <span class="wDamount">{{ brand.currency }} {{ postForm.amount > 0 ? postForm.amount : 0 | numberFormat }}</span>
                  </div>
                  <div class="detailList">
                    <b class="wDtitle">{{ $t('Bao.residual_bonus') }}</b>
                    <span class="wDamount">{{ brand.currency }} {{ bonusGold | numberFormat }}</span>
                  </div>
                </div>

                <div class="form-check">
                  <input
                    id="CheckDefault"
                    v-model="agree"
                    class="form-check-input"
                    type="checkbox"
                    value=""
                  >
                  <label for="CheckDefault">
                    {{ $t('Bao.agree_delete_bonus_tips') }}
                  </label>
                </div>

                <div
                  class="withdraw-sub"
                  type="submit"
                  :class="{ disabled: !checkInput() }"
                  @click="checkIsWithdraw()"
                >
                  {{ $t('Bao.send') }}
                </div>

                <div @click="$router.push('/page/support')">
                  <a class="help-deposit-n">
                    <span class="icon-help">?</span>
                    <span class="help-text">{{ $t('Bao.withdrawal_description') }}</span></a>
                </div>
              </form>
            </div>
          </div>
        </div><!-- mb end -->
      </div>
      <div class="my-withdraw-frame">
        <div class="my-deposit my-d-box">
          <div class="channel-text-n">
            {{ $t('Bao.withdraw') }}<span>{{ $t('Bao.select_a_wallet') }}</span>
          </div>
          <div class="slider-form withdraw-container">
            <template v-if="wallets.length > 0">
              <div class="my-wallet-out-frame slider">
                <div
                  :class="{'channel-cash-card-on': postForm.wallet === 'common',
                           'channel-cash-card': postForm.wallet !== 'common'}"
                  @click="selectWallet(wallets[0])"
                >
                  <div class="wallet-out-card">
                    <span>{{ $t('Bao.main_wallet') }}</span>
                    <span class="cash-card-title">
                      {{ brand.currency }} {{ formattedPrice(wallets[0].gold) | numberFormat }}
                    </span>
                  </div>
                </div>
                <div
                  :class="{'channel-cash-card-on': postForm.wallet === 'commission',
                           'channel-cash-card': postForm.wallet !== 'commission'}"
                  @click="selectWallet(wallets[1])"
                >
                  <div class="wallet-out-card">
                    <span>{{ $t('Bao.commission_wallet') }}</span>
                    <span class="cash-card-title">
                      {{ brand.currency }} {{ formattedPrice(wallets[1].gold) | numberFormat }}
                    </span>
                  </div>
                </div>
              </div>
            </template>
            <!-- pc  出金銀行選項-->
            <div class="my-wallet-out-frame2">
              <div
                v-if="availableWithdrawalTypes[2]"
                :class="{ 'channel-bank-cards-on': type === 2, 'channel-bank-cards': type !== 2 }"
                class="withdrawCF"
                @click="goNextStep(2)"
              >
                <div class="bank-choice-item-n withdrawWalletCard bank-choice">
                  <img :src="getThemeImagePath('electron-gold.svg')" alt="">
                  <div class="bank-choice-text">
                    <div>{{ $t('Bao.e_wallet') }}</div>
                    <p class="describe-n">
                      {{ $t('Bao.e-payment') }}
                    </p>
                  </div>
                </div>
              </div>

              <div
                v-if="availableWithdrawalTypes[1]"
                :class="{ 'channel-bank-cards-on': type === 1, 'channel-bank-cards': type !== 1 }"
                @click="goNextStep(1)"
              >
                <div class="bank-choice-item-n withdrawWalletCard bank-choice">
                  <img :src="getThemeImagePath('bankB-gold.svg')" alt="">
                  <div class="bank-choice-text">
                    <div>{{ $t('Bao.bank_card_2') }}</div>
                    <p class="describe-n">
                      {{ $t('Bao.internet_bank_app') }}
                    </p>
                  </div>
                </div>
              </div>

              <div
                v-if="availableWithdrawalTypes[3]"
                :class="{ 'channel-bank-cards-on': type === 3, 'channel-bank-cards': type !== 3 }"
                @click="goNextStep(3)"
              >
                <div class="bank-choice-item-n withdrawWalletCard bank-choice">
                  <img :src="getThemeImagePath('bitcoin-btc-gold.svg')" alt="">
                  <div class="bank-choice-text">
                    <div>{{ $t('Bao.cryptocurrency_for_withdrawal') }}</div>
                    <p class="describe-n">
                      {{ $t('Bao.bitcoin_ethereum') }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <!-- pc 出金選項 -->
            <div class="slider">
              <form class="row-frame dep-form-frame colu-12 form-row-gap">
                <div class="colu colu-9">
                  <label class="colu-12 for-label" for="カード/口座">{{ $t('Bao.card_or_address') }}</label>
                  <select
                    id="カード/口座"
                    v-model="postForm.member_bank_id"
                    class="for-select inpType"
                    @change="selectBank"
                  >
                    <option :value="selectedBankName">
                      {{ selectedBankName }}
                    </option>
                    <template v-for="(bank, key) in myBanks">
                      <option
                        v-if="bank.bank_type === type"
                        :key="key"
                        :value="bank.id"
                      >
                        {{ bank.card_number }}
                      </option>
                    </template>
                  </select>
                </div>
                <div class="colu colu-3">
                  <button class="btn btn-primary button-style btn-blackDarkBG" @click.prevent="$router.push('/user/bank')">
                    <img :src="getThemeImagePath('add.svg')" alt="">{{ $t('Bao.new_bank_card') }}
                  </button>
                </div>

                <div class="colu colu-9">
                  <label class="colu-12 for-label" for="出金額を入力してください">{{ $t('Bao.please_enter_withdrawal_amount') }}</label>
                  <input
                    id="出金額を入力してください"
                    v-model="postForm.amount"
                    class="for-input inpType"
                    type="text"
                    :placeholder="$t('Bao.input_withdrawal_amount')"
                  >
                </div>
                <div class="colu colu-3">
                  <button class="btn btn-primary button-style btn-blackDarkBG" @click.prevent="setAllAmount()">
                    {{ $t('Bao.withdrawal_all') }}
                  </button>
                </div>

                <template v-if="selectedBankTypeCode === 'JetonPay'">
                  <div class="form-input f-frame">
                    <label class="title-n" for="withdraw-amount">{{ $t('Bao.jeton_account') }}</label>
                    <div class="wallet-amount-frame">
                      <input
                        v-model="withdrawal_info.uid"
                        class="withdraw-amount-input"
                        type="text"
                        :placeholder="$t('Bao.jeton_account')"
                        autocomplete="off"
                        @input="checkJetonErrors"
                      >
                    </div>
                    <div v-for="error in jetonErrors" :key="error" class="help-block">
                      {{ error }}
                    </div>
                  </div>
                </template>
                <template v-if="selectedBankTypeCode === 'VegaWallet'">
                  <div class="form-input f-frame">
                    <label class="title-n" for="withdraw-amount">{{ $t('Bao.deposit_account') }}</label>
                    <div class="wallet-amount-frame">
                      <input
                        v-model="withdrawal_info.uid"
                        class="withdraw-amount-input"
                        type="text"
                        :placeholder="$t('Bao.deposit_account')"
                        autocomplete="off"
                        @input="checkAccountErrors"
                      >
                    </div>
                    <div v-for="error in accountErrors" :key="error" class="help-block">
                      {{ error }}
                    </div>
                    <label class="title-n" for="withdraw-amount">
                      {{ $t('Bao.deposit_password') }}
                    </label>
                    <div class="wallet-amount-frame">
                      <input
                        v-model="withdrawal_info.password"
                        v-validate="'required'"
                        class="withdraw-amount-input"
                        type="password"
                        name="password"
                        :placeholder="$t('Bao.deposit_password')"
                        autocomplete="off"
                      >
                    </div>
                    <div v-if="errors.has('password')" class="help-block">
                      {{ $t("Bao.deposit_password_error") }}
                    </div>
                  </div>
                </template>

                <div class="withdraw-detail-frame">
                  <div class="detailList">
                    <b class="wDtitle">{{ $t('Bao.withdraw_limit') }}</b>
                    <span class="wDamount">{{ brand.currency }} {{ withdrawalLimit }}</span>
                  </div>
                  <div class="detailList">
                    <b class="wDtitle">{{ $t('Bao.withdrawal_amount_tip_line_2') }}</b>
                    <span class="wDamount">{{ brand.currency }} {{ wallets.length > 0 ? selectedWallet.amount_limit.max : 0 | numberFormat }}</span>
                  </div>
                </div>

                <div class="colu colu-12">
                  <label class="colu-12 for-label" for="inputPassword">{{ $t("Bao.withdrawal_password") }}</label>
                  <input
                    id="inputPassword"
                    v-model="postForm.withdrawal_pass"
                    class="for-input inpType"
                    type="password"
                    :placeholder="$t('Bao.withdrawal_password_default')"
                  >
                </div>

                <div class="withdraw-detail-frame">
                  <div class="detailList">
                    <b class="wDtitle">{{ $t('Bao.total_amount') }}</b>
                    <span class="wDamount">{{ brand.currency }} {{ postForm.amount > 0 ? postForm.amount : 0 | numberFormat }}</span>
                  </div>
                  <div class="detailList">
                    <b class="wDtitle">{{ $t('Bao.residual_bonus') }}</b>
                    <span class="wDamount">{{ brand.currency }} {{ bonusGold | numberFormat }}</span>
                  </div>
                </div>

                <div class="form-check">
                  <input
                    id="CheckDefault"
                    v-model="agree"
                    class="form-check-input"
                    type="checkbox"
                    value=""
                  >
                  <label for="CheckDefault">
                    {{ $t('Bao.agree_delete_bonus_tips') }}
                  </label>
                </div>

                <div
                  class="withdraw-sub"
                  :class="{ disabled: !checkInput() }"
                  type="submit"
                  @click="checkIsWithdraw()"
                >
                  {{ $t('Bao.send') }}
                </div>
                <div @click="$router.push('/page/support')">
                  <a class="help-deposit-n"><span class="icon-help">?</span>
                    <span class="help-text"> {{ $t('Bao.withdrawal_description') }}</span></a>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showModel" class="popup-wrap" :class="{ active: showModel }">
      <div class="popup-box">
        <div class="popup-success">
          <h5>
            {{ handleWithdrawText }}
          </h5>
          <button class="button-style-5" @click="doWithdrawal">
            <span>{{ $t('Bao.submit') }}</span>
          </button>
          <button class="button-style-5" @click="hideModel">
            <span>{{ $t('Bao.cancel') }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { withdrawalCheck, withdrawalWallet, withdrawalPayment } from '@/api/payment'
import { getMyBanks } from '@/api/bank'
import { info } from '@/api/user'
import { showNotice, setErrorMessage, getThemeImagePath } from '@/utils/tool'
import crypto from 'crypto-js'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      type: 2, // 1:銀行卡, 2:電子錢包, 3:虛擬貨幣
      myBanks: [],
      selectedBankName: this.$t('Bao.select_bankcard'),
      selectedBankTypeCode: '',
      wallets: [],
      selectedWallet: null,
      withdrawalCheck: {
        'amount': null,
        'withdrawal_fee': null,
        'actual_amount': null,
        'status': null,
        'require_performance': null,
        'performance_need': null,
        'current_performance': null
      },
      agree: false,
      postForm: {
        wallet: 'common',
        amount: '',
        withdrawal_pass: null,
        member_bank_id: this.$t('Bao.select_bankcard')
      },
      withdrawal_info: [],
      accountErrors: [' '],
      isElectronActive: true,
      isBankActive: false,
      isBitcoinActive: false,
      showModel: false,
      availableWithdrawalTypes: {
        1: false, // bank card
        2: false, // e-wallet
        3: false // cryptocurrency
      }
    }
  },
  computed: {
    ...mapGetters(['memberInfo', 'brand', 'brandInfo', 'bonusGold']),
    before_withdrawal_module_setting() {
      return this.brandInfo.before_withdrawal_module_setting
    },
    max_withdrawal_amount() {
      return this.before_withdrawal_module_setting ? this.before_withdrawal_module_setting.max_withdrawal_amount : 0
    },
    handleWithdrawText() {
      return this.$t('Bao.is_handle_withdraw', { limit: this.max_withdrawal_amount })
    },
    first_deposit_at() {
      return this.memberInfo.first_deposit_at
    },
    withdrawalLimit() {
      const limit = parseFloat(this.memberInfo.withdrawal_limit) - parseFloat(this.memberInfo.main_turnover)
      return limit > 0 ? parseFloat(limit.toFixed(4)) : 0
    }
  },
  created() {
    if (this.memberInfo.member_type === 3 && this.memberInfo.withdrawal_pass === '') {
      this.$router.push('/user/edit') // 是lite player
    } else if (this.memberInfo.is_pass_KYC === 0 && this.memberInfo.member_type !== 3) {
      this.$router.push('/user/edit') // 通過KYC且不是lite player
    } else if (this.memberInfo.is_pass_KYC === 2 && this.memberInfo.member_type !== 3) {
      if (this.brand.info.kyc_brand !== 'self') {
        this.$router.push('/user/edit')
      } else {
        this.$router.push('/user/KYC') // 尚未通過KYC且不是lite player
      }
    }

    withdrawalWallet().then((response) => {
      this.wallets = response.data.data
      this.selectedWallet = this.wallets[0]
    }).catch((error) => {
      const result = error.response.data
      if (result.status === 403) {
        showNotice(result.msg, () => {
          this.$router.push('/')
        })
      } else {
        showNotice(result.msg, () => {}, true, false, '')
        if (result.data.type === 'info') {
          this.$router.push({ path: '/user/edit' }).catch(() => {
          })
        } else if (result.data.type === 'bank_card') {
          this.$router.push({ path: '/user/bank/create' }).catch(() => {
          })
        }
      }
    })

    getMyBanks().then((response) => {
      this.myBanks = response.data.data
      this.checkAvailableWithdrawalTypes()
    }).catch((e) => {
      setErrorMessage(e)
    })

    if (this.withdrawalLimit !== 0) {
      showNotice(this.$t('Bao.no_withdrawal_limit', { limit: this.withdrawalLimit }))
    }
    if (this.first_deposit_at === 0) {
      info().then(response => {
        const reqData = response.data
        this.$store.dispatch('SetUserData', reqData.data)
      })
    }
  },
  methods: {
    hideModel() {
      this.showModel = false
    },
    checkIsWithdraw() {
      if (this.postForm.amount <= 0 || isNaN(this.postForm.amount)) {
        showNotice(this.$t('Bao.withdrawal_amount') + ' ' + this.$t('Bao.need_over_zero'))
        return false
      }

      if (this.postForm.wallet !== 'commission') {
        if (this.first_deposit_at === 0 && this.before_withdrawal_module_setting !== null) {
          if (this.postForm.amount > this.max_withdrawal_amount) {
            this.postForm.amount = this.max_withdrawal_amount
          }

          this.showModel = true
        } else {
          this.doWithdrawal()
        }
      } else {
        this.doWithdrawal()
      }
    },
    selectBank(event) {
      const selectedBankId = event.target.value
      const selectedBankType = this.myBanks.find(bank => bank.id.toString() === selectedBankId.toString())
      this.selectedBankTypeCode = selectedBankType.code
    },
    selectWallet(wallet) {
      this.selectedWallet = wallet
      this.postForm.wallet = wallet.key
    },
    setAllAmount() {
      this.postForm.amount = this.selectedWallet['amount_limit'].max
    },
    checkInput() {
      let result = false
      if (!isNaN(this.postForm.member_bank_id) && this.agree &&
      this.postForm.withdrawal_pass && this.postForm.amount !== '') {
        result = true

        if (this.selectedBankTypeCode === 'VegaWallet') {
          const accountErrors = this.accountErrors
          if (!this.withdrawal_info.password || accountErrors.length > 0) { result = false }
        }
        if (this.selectedBankTypeCode === 'JetonPay') {
          const accountErrors = this.jetonErrors
          if (accountErrors.length > 0) { result = false }
        }
      }

      return result
    },
    doWithdrawal() {
      this.showModel = false

      const self = this

      withdrawalCheck({ amount: this.postForm.amount, wallet: this.postForm.wallet }).then((response) => {
        if (response.data.data.status === 'deny') {
          showNotice(response.data.data.message)
        } else {
          this.withdrawalCheck = response.data.data
        }
      }).catch(() => {
        console.log('Cannot get wallet type')
      })

      const encryptedPostForm = { ...this.postForm }

      // 如果提款方式為 'VegaWallet',則加密密碼
      if (this.selectedBankTypeCode === 'VegaWallet') {
        encryptedPostForm.withdrawal_info = { ...this.withdrawal_info }
        encryptedPostForm.withdrawal_info.password = crypto.MD5(encryptedPostForm.withdrawal_info.password).toString()
      } else if (this.selectedBankTypeCode === 'JetonPay') {
        encryptedPostForm.withdrawal_info = { ...this.withdrawal_info }
      } else {
        // 其他提款方式,不需要帳號密碼
        delete encryptedPostForm.withdrawal_info
      }

      const encryptedOtherString = JSON.stringify(encryptedPostForm.withdrawal_info)

      withdrawalPayment({ ...encryptedPostForm, withdrawal_info: encryptedOtherString }).then((response) => {
        showNotice(response.data.msg, function() {
          self.$router.push({ path: '/user/withdrawal-record' })
        })
      }).catch((error) => {
        setErrorMessage(error.response, this.errors)
      })
    },
    goNextStep(type, typeName) {
      if (type === undefined) {
        type = 2
      }
      this.postForm.member_bank_id = this.$t('Bao.select_bankcard')
      this.type = type

      this.isElectronActive = typeName === 'electron' ? !this.isElectronActive : false
      this.isBankActive = typeName === 'bank' ? !this.isBankActive : false
      this.isBitcoinActive = typeName === 'bitcoin' ? !this.isBitcoinActive : false
    },
    formattedPrice(price) {
      return parseInt(price)
    },
    checkAccountErrors() {
      this.accountErrors = []
      if (!this.withdrawal_info.uid) {
        this.accountErrors.push(this.$t('Bao.deposit_account_error'))
      } else if (!/^[a-zA-Z]\d{6}$/.test(this.withdrawal_info.uid)) {
        this.accountErrors.push(this.$t('Bao.deposit_account_error'))
      }
    },
    checkJetonErrors() {
      this.jetonErrors = []
      if (!this.withdrawal_info.uid) {
        this.jetonErrors.push(this.$t('Bao.jeton_account_error'))
      } else if (!/^\d+$/.test(this.other.uid)) {
        this.jetonErrors.push(this.$t('Bao.jeton_account_error'))
      }
    },
    getThemeImagePath,
    checkAvailableWithdrawalTypes() {
      this.availableWithdrawalTypes = {
        1: false,
        2: false,
        3: false
      }

      const banksByType = {}
      this.myBanks.forEach(bank => {
        if (!banksByType[bank.bank_type]) {
          banksByType[bank.bank_type] = []
        }
        banksByType[bank.bank_type].push(bank)
      })

      Object.entries(banksByType).forEach(([type, banks]) => {
        const hasAvailablePayments = banks.some(bank =>
          Array.isArray(bank.payments) && bank.payments.length > 0
        )

        if (hasAvailablePayments) {
          switch (parseInt(type)) {
            case 1:
              this.availableWithdrawalTypes[1] = true // Bank card
              break
            case 2:
              this.availableWithdrawalTypes[2] = true // E-wallet
              break
            case 3:
              this.availableWithdrawalTypes[3] = true // Cryptocurrency
              break
          }
        }
      })

      // If current type is not available, switch to first available type
      if (!this.availableWithdrawalTypes[this.type]) {
        const firstAvailableType = Object.entries(this.availableWithdrawalTypes)
          .find(([_, isAvailable]) => isAvailable)

        if (firstAvailableType) {
          this.goNextStep(parseInt(firstAvailableType[0]))
        }
      }
    }
  }
}
</script>

<style scoped>
.popup-success button.button-style-5 {
    margin-left: 10px;
}
</style>
